<template>
  <section class="section-wrap">
    <Swiper
      :modules="[Autoplay]"
      :effect="'creative'"
      :speed="1000"
      :autoplay="{delay: 3000, disableOnInteraction: false}"
      :loop="true"
      :slides-per-view="1"
      class="mySwiper"
    >
      <SwiperSlide v-for="item in advertiseList" :key="item.id">
        <div class="img-wrap" @click="clickAdvertise(item.link)">
          <div class="swip-item" :style="{backgroundImage: `url(${item.imgPath})`}" />
        </div>
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<script>
import {Autoplay, Pagination} from 'swiper/modules'

export default {
  name: 'Section8',
  props: {
    advertiseList: {
      type: Array
    }
  },
  data() {
    return {
      Autoplay,
      Pagination
    }
  },
  methods: {
    clickAdvertise(link) {
      if (link) {
        window.open(link, '_blank')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.section-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
  width: 1080px;
  margin: 0 auto;

  .img-wrap {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1080px;
    margin: 0 auto;

    .swip-item {
      flex: 1;
      height: 256px;
      border-radius: 20px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
</style>
